import { en } from "../en";

export const en_us = {
  ...en
};
